import { Col, Form, Row } from 'antd';
import { TextInput } from 'components/UI/FormItems';
import { FormRadio } from 'components/UI/FormItems/Radio';
import { useFormikContext } from 'formik';
import { CreateUserPayload } from 'models/Users';
import { useLocation } from 'react-router-dom';

export const UserForm = (): JSX.Element => {
  // Hooks
  const { values, initialTouched, touched, errors } = useFormikContext();
  const { pathname } = useLocation();
  const isProfilePage = pathname.includes('/profile');

  // Render
  return (
    <Form layout="vertical">
      <Row gutter={[32, 16]}>
        <Col span={24}>
          <TextInput fieldName="givenName" label="First Name" />
        </Col>
        <Col span={24}>
          <TextInput fieldName="familyName" label="Last Name" />
        </Col>
        <Col span={24}>
          <TextInput fieldName="phoneNumber" label="Phone Number" />
        </Col>
        <Col span={24}>
          <TextInput fieldName="email" label="Email" />
        </Col>
        {!isProfilePage && (
          <Col span={24}>
            <FormRadio fieldName="isMdsiEmployee" label="Are you an MDSi Employee" />
          </Col>
        )}
        {(values as CreateUserPayload).isMdsiEmployee && (
          <Col span={24}>
            <TextInput fieldName="employeeERPId" label="Employee ERP ID" />
          </Col>
        )}
      </Row>
    </Form>
  );
};
